import { FormItem, MenuPresets, SelectInput, TextInput } from '@framework/form';
import { Collapse } from 'antd';
import React, { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { RichTextAdvancedInput } from '../../../../../inputs';
import { StyledDrawerCollapse } from '../../../../../ui/drawer';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { ISubsectionWidget } from './ISubsectionWidget';
import { SubsectionRendering } from './SubsectionRendering';
import { SubsectionEditor } from './components/SubsectionEditor';
import { SubsectionConfigContainer } from './style/SubsectionConfigContainer';
const { Panel } = Collapse;

export interface ISubsectionConfigComponentProps
  extends IWidgetComponentProps<ISubsectionWidget> {}

export function SubsectionConfigComponent(
  props: ISubsectionConfigComponentProps,
) {
  const renderingKind = useWatch({ name: 'rendering' }) as SubsectionRendering;

  const renderingHelp = useMemo(() => {
    switch (renderingKind) {
      case SubsectionRendering.Drawer:
        return 'La sottosezione verrà visualizzata in un pannello dedicato';
      case SubsectionRendering.Inline:
        return 'La sottosezione verrà visualizzata in linea nel modulo';
      case SubsectionRendering.Hidden:
        return 'La sottosezione verrà nascosta e visibile attraverso azione dedicata';
      default:
        return '';
    }
  }, [renderingKind]);

  return (
    <div>
      <StyledDrawerCollapse defaultActiveKey={['general', 'editor']} ghost>
        <Panel header="Impostazioni Generali" key="general">
          <div>
            <FormItem
              name="rendering"
              label="Visualizzazione"
              help={renderingHelp}
            >
              <SelectInput
                name="rendering"
                defaultValue={SubsectionRendering.Drawer}
                options={[
                  {
                    label: 'Pannello dedicato',
                    value: SubsectionRendering.Drawer,
                  },
                  { label: 'In linea', value: SubsectionRendering.Inline },
                  { label: 'Nascosta', value: SubsectionRendering.Hidden },
                ]}
              />
            </FormItem>
            <FormItem name="code" label="Codice">
              <TextInput name="code" />
            </FormItem>

            <FormItem name="label" label="Titolo">
              <RichTextAdvancedInput
                name="label"
                menus={MenuPresets.Inline}
                rows={3}
              />
            </FormItem>
            {renderingKind === SubsectionRendering.Drawer && (
              <FormItem name="placeholder" label="Testo pulsante">
                <TextInput name="placeholder" defaultValue="Apri" />
              </FormItem>
            )}
            {/* <FormItem name="viewInResume" layout={{ removeLabelSpace: true }}>
              <CheckboxInput name="viewInResume" defaultChecked={false}>
                Visualizza sottosezione in riepilogo compilazione
              </CheckboxInput>
            </FormItem> */}
          </div>
        </Panel>

        <Panel header="Editor Sottosezione" key="editor">
          <SubsectionConfigContainer>
            {/* Editor DnD dei componenti */}
            <SubsectionEditor renderingKind={renderingKind} />
          </SubsectionConfigContainer>
        </Panel>
      </StyledDrawerCollapse>
    </div>
  );
}
